import React from 'react';
import Card from '../../../components/ACS-Dashboard/ACS-Blocks/Card';
import ScrollableContainer from '../../../components/ACS-Dashboard/ACS-Blocks/ScrollableContainer';

const NotificationList = ({ isCollapsed }) => {
  // Sample data for the scrollable cards
  const cardsData = [
    { title: "Delivered Shipments", percentage: "+10%", comparisonText: "vs last week", mainValue: "25", buttonText: "View", module: "Shipment" },
    { title: "In-transit Shipments", percentage: "+5%", comparisonText: "vs yesterday", mainValue: "15", buttonText: "Track", module: "Shipment" },
    { title: "Delayed Shipments", percentage: "-1%", comparisonText: "vs last month", mainValue: "3", buttonText: "Check", module: "Shipment" },
    { title: "Approved Invoices", percentage: "+12%", comparisonText: "vs last week", mainValue: "42", buttonText: "View", module: "Invoice" },
    { title: "Rejected Invoices", percentage: "-3%", comparisonText: "vs last month", mainValue: "7", buttonText: "Fix", module: "Invoice" },
    { title: "Pending Invoices", percentage: "+6%", comparisonText: "vs yesterday", mainValue: "18", buttonText: "Review", module: "Invoice" },
    { title: "Signed Contracts", percentage: "+8%", comparisonText: "vs last week", mainValue: "11", buttonText: "Details", module: "Contracts" },
    { title: "Pending Contracts", percentage: "+2%", comparisonText: "vs yesterday", mainValue: "5", buttonText: "Check", module: "Contracts" },
    { title: "Expired Contracts", percentage: "-4%", comparisonText: "vs last month", mainValue: "2", buttonText: "Renew", module: "Contracts" }
  ];  

  return (
    <div className="p-fluid-1 bg-color-custom-bg-purple">
      <ScrollableContainer direction="x" className="scrollbar-none">
        <div className="flex gap-[clamp(0.5rem,1cqw,1rem)]">
          {cardsData.map((card, index) => (
            <div 
              key={index} 
              className="scroll-snap-align-start"
              style={{ 
                minWidth: 'clamp(12rem,30cqw,11rem)',
                flex: '0 0 auto'
              }}
            >
              <Card 
                {...card}
                className="p-fluid-1.5"
                titleClassName="text-fluid-lg"
                valueClassName="text-fluid-xl"
                metaClassName="text-fluid-sm"
              />
            </div>
          ))}
        </div>
      </ScrollableContainer>
    </div>
  );
};

export default NotificationList;
